import React, { useEffect, useState } from 'react';
import { api, apiError } from '../../lib/api';

const PILL = {
  planned: { cls: 'pill-pending', label: 'Planned' },
  completed: { cls: 'pill-approved', label: 'Completed' },
  no_response: { cls: 'pill-rejected', label: 'No response' },
  follow_up: { cls: 'pill-in_progress', label: 'Follow-up' },
};

export default function AdminVisits() {
  const [visits, setVisits] = useState([]);
  const [err, setErr] = useState('');
  const [q, setQ] = useState({ employee_id: '', business_id: '' });

  const load = async () => {
    try {
      const params = new URLSearchParams();
      if (q.employee_id) params.set('employee_id', q.employee_id);
      if (q.business_id) params.set('business_id', q.business_id);
      const { data } = await api.get('/admin/visits?' + params.toString());
      setVisits(data.visits || []);
    } catch (e) { setErr(apiError(e)); }
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  return (
    <div data-testid="admin-visits">
      <h2 className="mb-3">Field visits</h2>
      {err && <div className="alert alert-danger">{err}</div>}
      <div className="ap-card mb-3">
        <div className="d-flex gap-2 flex-wrap">
          <input className="form-control" style={{ maxWidth: 200 }} placeholder="Employee ID" value={q.employee_id} onChange={e => setQ({ ...q, employee_id: e.target.value })} data-testid="av-emp"/>
          <input className="form-control" style={{ maxWidth: 200 }} placeholder="Business ID" value={q.business_id} onChange={e => setQ({ ...q, business_id: e.target.value })} data-testid="av-biz"/>
          <button className="btn-ap-outline" onClick={load} data-testid="av-filter">Filter</button>
        </div>
      </div>
      <div className="ap-card p-0 overflow-auto">
        <table className="ap-table">
          <thead><tr><th>Date</th><th>Employee</th><th>Business</th><th>Status</th><th>Purpose / notes</th><th>Follow-up</th><th></th></tr></thead>
          <tbody>
            {visits.map(v => (
              <tr key={v.id} data-testid={`av-row-${v.id}`}>
                <td>{new Date(v.created_at).toLocaleString()}</td>
                <td>
                  <div className="fw-semibold">{v.employee_name}</div>
                  <div className="small text-muted-2">{v.employee_email}</div>
                </td>
                <td>{v.business_name}</td>
                <td><span className={'pill ' + (PILL[v.status]?.cls || 'pill-disabled')}>{PILL[v.status]?.label || v.status}</span></td>
                <td style={{ maxWidth: 260 }}>
                  {v.purpose && <div className="fw-semibold small">{v.purpose}</div>}
                  <div className="small text-muted-2">{v.notes}</div>
                </td>
                <td>{v.next_follow_up ? new Date(v.next_follow_up).toLocaleString() : '—'}</td>
                <td>
                  {v.latitude && v.longitude && <a className="btn-ap-outline btn-sm me-1" href={`https://maps.google.com/?q=${v.latitude},${v.longitude}`} target="_blank" rel="noreferrer" data-testid={`av-map-${v.id}`}>Map</a>}
                  {v.photo_url && <a className="btn-ap-outline btn-sm" href={(process.env.REACT_APP_BACKEND_URL || '') + v.photo_url} target="_blank" rel="noreferrer" data-testid={`av-photo-${v.id}`}>Photo</a>}
                </td>
              </tr>
            ))}
            {visits.length === 0 && <tr><td colSpan="7" className="text-center py-4 text-muted-2">No visits recorded.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
